// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { PaymentMethodRequestDTO } from '../models';
import { PaymentPlanActionDTO } from '../models';
import { UpdateAddressHistoryAttributesDTO } from '../models';
/**
 * PaymentPlanActionsApi - axios parameter creator
 * @export
 */
export const PaymentPlanActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Complete a confirm payment plan action
         * @param {string} paymentPlanId PaymentPlanId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPaymentPlan(paymentPlanId: string, options: any = {}): RequestArgs {
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling confirmPaymentPlan.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/actions/confirm`
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a payment plan action by id
         * @param {string} id Payment plan action id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanAction(id: string, paymentPlanId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPaymentPlanAction.');
            }
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling getPaymentPlanAction.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/actions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user address when setting up a payment plan
         * @param {string} paymentPlanId PaymentPlanId
         * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(paymentPlanId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options: any = {}): RequestArgs {
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling updateAddress.');
            }
            // verify required parameter 'updateAddressHistoryAttributesDTO' is not null or undefined
            if (updateAddressHistoryAttributesDTO === null || updateAddressHistoryAttributesDTO === undefined) {
                throw new RequiredError('updateAddressHistoryAttributesDTO','Required parameter updateAddressHistoryAttributesDTO was null or undefined when calling updateAddress.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/actions/address`
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateAddressHistoryAttributesDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAddressHistoryAttributesDTO !== undefined ? updateAddressHistoryAttributesDTO : {}) : (updateAddressHistoryAttributesDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Collect card details when setting up a payment plan
         * @param {string} paymentPlanId 
         * @param {PaymentMethodRequestDTO} paymentMethodRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardDetails(paymentPlanId: string, paymentMethodRequestDTO: PaymentMethodRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling updateCardDetails.');
            }
            // verify required parameter 'paymentMethodRequestDTO' is not null or undefined
            if (paymentMethodRequestDTO === null || paymentMethodRequestDTO === undefined) {
                throw new RequiredError('paymentMethodRequestDTO','Required parameter paymentMethodRequestDTO was null or undefined when calling updateCardDetails.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/actions/card-details`
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PaymentMethodRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(paymentMethodRequestDTO !== undefined ? paymentMethodRequestDTO : {}) : (paymentMethodRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentPlanActionsApi - functional programming interface
 * @export
 */
export const PaymentPlanActionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Complete a confirm payment plan action
         * @param {string} paymentPlanId PaymentPlanId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPaymentPlan(paymentPlanId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).confirmPaymentPlan(paymentPlanId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Fetch a payment plan action by id
         * @param {string} id Payment plan action id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanAction(id: string, paymentPlanId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanActionDTO> {
            const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).getPaymentPlanAction(id, paymentPlanId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update user address when setting up a payment plan
         * @param {string} paymentPlanId PaymentPlanId
         * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(paymentPlanId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).updateAddress(paymentPlanId, updateAddressHistoryAttributesDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Collect card details when setting up a payment plan
         * @param {string} paymentPlanId 
         * @param {PaymentMethodRequestDTO} paymentMethodRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardDetails(paymentPlanId: string, paymentMethodRequestDTO: PaymentMethodRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).updateCardDetails(paymentPlanId, paymentMethodRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PaymentPlanActionsApi - factory interface
 * @export
 */
export const PaymentPlanActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Complete a confirm payment plan action
         * @param {string} paymentPlanId PaymentPlanId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPaymentPlan(paymentPlanId: string, options?: any) {
            return PaymentPlanActionsApiFp(configuration).confirmPaymentPlan(paymentPlanId, options)(axios, basePath);
        },
        /**
         * Fetch a payment plan action by id
         * @param {string} id Payment plan action id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanAction(id: string, paymentPlanId: string, options?: any) {
            return PaymentPlanActionsApiFp(configuration).getPaymentPlanAction(id, paymentPlanId, options)(axios, basePath);
        },
        /**
         * Update user address when setting up a payment plan
         * @param {string} paymentPlanId PaymentPlanId
         * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(paymentPlanId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any) {
            return PaymentPlanActionsApiFp(configuration).updateAddress(paymentPlanId, updateAddressHistoryAttributesDTO, options)(axios, basePath);
        },
        /**
         * Collect card details when setting up a payment plan
         * @param {string} paymentPlanId 
         * @param {PaymentMethodRequestDTO} paymentMethodRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardDetails(paymentPlanId: string, paymentMethodRequestDTO: PaymentMethodRequestDTO, options?: any) {
            return PaymentPlanActionsApiFp(configuration).updateCardDetails(paymentPlanId, paymentMethodRequestDTO, options)(axios, basePath);
        },
    };
};

/**
 * PaymentPlanActionsApi - interface
 * @export
 * @interface PaymentPlanActionsApi
 */
export interface PaymentPlanActionsApiInterface {
    /**
     * Complete a confirm payment plan action
     * @param {string} paymentPlanId PaymentPlanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApiInterface
     */
    confirmPaymentPlan(paymentPlanId: string, options?: any): AxiosPromise<{}>;

    /**
     * Fetch a payment plan action by id
     * @param {string} id Payment plan action id
     * @param {string} paymentPlanId Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApiInterface
     */
    getPaymentPlanAction(id: string, paymentPlanId: string, options?: any): AxiosPromise<PaymentPlanActionDTO>;

    /**
     * Update user address when setting up a payment plan
     * @param {string} paymentPlanId PaymentPlanId
     * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApiInterface
     */
    updateAddress(paymentPlanId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any): AxiosPromise<{}>;

    /**
     * Collect card details when setting up a payment plan
     * @param {string} paymentPlanId 
     * @param {PaymentMethodRequestDTO} paymentMethodRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApiInterface
     */
    updateCardDetails(paymentPlanId: string, paymentMethodRequestDTO: PaymentMethodRequestDTO, options?: any): AxiosPromise<{}>;

}

/**
 * PaymentPlanActionsApi - object-oriented interface
 * @export
 * @class PaymentPlanActionsApi
 * @extends {BaseAPI}
 */
export class PaymentPlanActionsApi extends BaseAPI implements PaymentPlanActionsApiInterface {
    /**
     * Complete a confirm payment plan action
     * @param {string} paymentPlanId PaymentPlanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApi
     */
    public confirmPaymentPlan(paymentPlanId: string, options?: any) {
        return PaymentPlanActionsApiFp(this.configuration).confirmPaymentPlan(paymentPlanId, options)(this.axios, this.basePath);
    }

    /**
     * Fetch a payment plan action by id
     * @param {string} id Payment plan action id
     * @param {string} paymentPlanId Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApi
     */
    public getPaymentPlanAction(id: string, paymentPlanId: string, options?: any) {
        return PaymentPlanActionsApiFp(this.configuration).getPaymentPlanAction(id, paymentPlanId, options)(this.axios, this.basePath);
    }

    /**
     * Update user address when setting up a payment plan
     * @param {string} paymentPlanId PaymentPlanId
     * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApi
     */
    public updateAddress(paymentPlanId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any) {
        return PaymentPlanActionsApiFp(this.configuration).updateAddress(paymentPlanId, updateAddressHistoryAttributesDTO, options)(this.axios, this.basePath);
    }

    /**
     * Collect card details when setting up a payment plan
     * @param {string} paymentPlanId 
     * @param {PaymentMethodRequestDTO} paymentMethodRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanActionsApi
     */
    public updateCardDetails(paymentPlanId: string, paymentMethodRequestDTO: PaymentMethodRequestDTO, options?: any) {
        return PaymentPlanActionsApiFp(this.configuration).updateCardDetails(paymentPlanId, paymentMethodRequestDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for PaymentPlanActionsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Complete a confirm payment plan action
 * @param {string} paymentPlanId PaymentPlanId
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function confirmPaymentPlan(
    paymentPlanId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).confirmPaymentPlan(paymentPlanId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Fetch a payment plan action by id
 * @param {string} id Payment plan action id
 * @param {string} paymentPlanId Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getPaymentPlanAction(
    id: string,
    paymentPlanId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanActionDTO> {
    const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).getPaymentPlanAction(id, paymentPlanId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update user address when setting up a payment plan
 * @param {string} paymentPlanId PaymentPlanId
 * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateAddress(
    paymentPlanId: string,
    updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).updateAddress(paymentPlanId, updateAddressHistoryAttributesDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Collect card details when setting up a payment plan
 * @param {string} paymentPlanId 
 * @param {PaymentMethodRequestDTO} paymentMethodRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateCardDetails(
    paymentPlanId: string,
    paymentMethodRequestDTO: PaymentMethodRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = PaymentPlanActionsApiAxiosParamCreator(configuration).updateCardDetails(paymentPlanId, paymentMethodRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

